import { execute, gql, type VariablesOf } from './financial-bff-gql'

export const TARGET_INCENTIVES_SUMMARY = gql(`
  query TargetIncentivesSummary($targetId: String!, $campaignType: String!, $targetType: String!) {
    targetIncentivesSummary(target_id: $targetId, campaign_type: $campaignType, target_type: $targetType) {
      incentive {
        banner_url
        description_ptbr
        title_ptbr
      }
    }
  }
`)

export type TargetIncentivesSummaryVariables = VariablesOf<typeof TARGET_INCENTIVES_SUMMARY>

export async function fetchTargetIncentivesSummary(variables: TargetIncentivesSummaryVariables) {
  const data = await execute(TARGET_INCENTIVES_SUMMARY, variables)
  return data.targetIncentivesSummary?.incentive ?? null
}
